<template>
  <BaseCleanPopup
    v-body
    :mask="true"
    @close="closeWin"
    ref="popup"
    :h="40"
    :w="300"
    :winh="446"
    :winw="317"
    v-zindex
  >
    <template v-slot:header>
      <div>{{ $t("general.ImportantMsg") }}</div>
    </template>
    <div class="content">
      <div class="msgs">
        <!-- TODO add some class accrodding to msg.status (pending/done/running) -->
        <p v-for="msg in msgs" :key="msg.id">* {{ msg.msg }}</p>
      </div>
      <div class="bottom">
        <base-button @click="start">{{ $t("general.play") }}</base-button>
      </div>
    </div>
  </BaseCleanPopup>
</template>

<script>
import { mapActions } from "vuex";
import BaseButton from "../BaseComponents/BaseButton.vue";

export default {
  components: { BaseButton },
  data() {
    return {
      startActions: false,
    };
  },
  computed: {
    msgs() {
      return this.$store.state.WaitTasks.tasks;
    },
  },
  methods: {
    ...mapActions("WaitTasks", [
      "completeAction",
      "errAction",
      "delAction",
      "cleanDone",
      "delAllDoneActions",
    ]),
    closeWin() {
      this.cleanDone();
      this.$store.state.WaitTasks.show = false;
    },
    async start() {
      if (this.startActions) return;
      this.startActions = true;
      const actions = this.msgs;
      for (let i = 0; i < actions.length; i++) {
        const fn = actions[i].action;
        const id = actions[i].id;
        try {
          const id = (actions[i].status = "running");
          await fn();

          this.completeAction(id);
        } catch {
          //mark actions with error
          this.errAction(id);
        }
        this.delAllDoneActions();
        this.startActions = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.msgs {
  flex-grow: 1;
}
.bottom {
  padding: 10px;
}
</style>
